
import { defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { orders } from '@/composables/orders'

export default defineComponent(
{
    name: 'Header',
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()

        // Computed state params:
        const isAuthenticated = computed(() =>
        {
            return store.getters['auth/isAuthenticated']
        })
        // Get user data:
        const authenticatedUser = computed(() =>
        {
            return store.getters['auth/getUser']
        })
        const getBasketCount = computed(() =>
        {
            return store.getters['basket/getBasketCount']
        })

        // Orders badge count. A single-record page is enough: the count comes
        // from the operation's paging metadata (resultsCount — see
        // ordersCount in composables/orders.ts), not from pulling every grant.
        // The read fires once at boot / sign-in and again only when a payment
        // is confirmed (orders/markChanged) — never signed-out, never on route
        // changes.
        const {
            ordersCount
        } = orders(1)

        // Set menu items:
        const menuItems = computed(() =>
        {
            // Start items array:
            const items = []
            // Add items based on authenticaion:
            if(getBasketCount.value > 0)
            {
                items.push(
                {
                    name: 'Basket',
                    text: 'My Basket (' + getBasketCount.value + ')'
                })
            }

            // Add items based on authenticaion:
            if(isAuthenticated.value)
            {
                // My Orders is always reachable when signed in — it is the
                // customer's order history (including expired orders) — with
                // the count appended once they have paid orders. It used to be
                // gated on the boot-time count (HM-478), so a first order
                // placed mid-session left no way back to /orders until a
                // reload (STG tester report, 2026-09-22).
                items.push(
                {
                    name: 'Orders',
                    text: 'My Orders' + (ordersCount.value > 0 ? ' (' + ordersCount.value + ')' : '')
                })
                items.push(
                {
                    name: 'Account',
                    text: 'My Account'
                })
            }
            else
            {
                items.push({
                    name: 'Register',
                    text: 'Create an account'
                })
                items.push({
                    name: 'Login',
                    text: 'Sign in'
                })
            }
            // Add remaining items:
            items.push(
            {
                name: 'Help',
                text: 'Help'
            })
            items.push(
            {
                name: 'Release notes',
                text: 'Release notes'
            })

            return items
        })

        // Set visible:
        const isMenuVisible = ref(false)
        // Compute classes for menu:
        const menuClassList = computed(() =>
        {
            return {
                'govuk-header__navigation': true,
                'govuk-header__navigation--open': isMenuVisible.value
            }
        })

        // Logout function:
        const handleLogout = function()
        {
            store.commit('auth/logout')
            router.push({ name: 'Home' })
        }

        // Return data:
        return {
            isAuthenticated,
            getBasketCount,
            menuItems,
            isMenuVisible,
            menuClassList,
            handleLogout
        }
    }
})
